import React, { useContext } from 'react'
import { userContext } from 'global/context/sub-contexts/userContext'
import { Link, navigate } from 'gatsby'
import UserImage from 'components/UserImage'
import { logout } from 'services/auth'
import localStorageWrapper from 'util/LocalStorageWrapper'

import './ProfileDropdown.scss'

const ProfileDropdown = () => {
  const user_context = useContext(userContext)

  const handleLogout = () => {
    logout().then(result => {
      if (result.success === true) {
        navigate('/')
        user_context.logout()
        clearCompletedBrks()
      } else {
        // TODO: better handling. what would cause this to happen?
        alert(result.message)
      }
    })
  }

  const clearCompletedBrks = () => {
    if (!window) return false
    localStorageWrapper.removeItem('db_completed_brks')
  }

  return (
    <div className="profile-container">
      <Link to="/profile" className="user__avatar">
        <UserImage />
      </Link>
      <ul className="dropdown">
        <li>
          <Link to="/profile">Profile</Link>
        </li>
        <li>
          <Link to="/settings">Settings</Link>
        </li>
        <li>
          <span onClick={handleLogout}>Sign Out</span>
        </li>
      </ul>
    </div>
  )
}

export default ProfileDropdown
